<template>
    <div>
        <!-- 头部 -->
        <index-header></index-header>
        <!-- 头图 -->
        <div>
            <el-carousel height="500px">
                <el-carousel-item
                    v-for="(item, index) in ast['kkhoofs7-img'].body"
                    :key="index"
                    class="tc"
                >
                    <a :href="item.attributeMap.href.value.value">
                        <img
                            :src="item.body[0].attributeMap.src.value.value"
                            :alt="item.body[0].attributeMap.alt.value.value"
                            style="max-height: 500px"
                        />
                    </a>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!-- 主要内容 -->
        <div class="tc">
            <!-- 推荐产品 -->
            <div id="kkgqz3uu-recommend">
                <div class="w1200 dib tl">
                    <div class="kkhninjr-title dib">
                        <img
                            class="mr10 vm"
                            src="@/assets/img/index/title-before.png"
                            alt=""
                        />
                        <span class="fs16 fwb c_theme vm mr10">{{
                            ast["kkhnzbxa-recommend"].body[0].body[0].body[0]
                                .value
                        }}</span>
                        <a
                            :href="
                                ast['kkhnzbxa-recommend'].body[0].body[1]
                                    .attributeMap.href.value.value
                            "
                            class="c9 fs12 vb"
                            >{{
                                ast["kkhnzbxa-recommend"].body[0].body[1]
                                    .body[0].value
                            }}</a
                        >
                    </div>
                    <div class="cf">
                        <!-- 左边--列表 -->
                        <ul id="kkhotfo8-reList" class="fl">
                            <li
                                v-for="(item, index) in ast[
                                    'kkhnzbxa-recommend'
                                ].body[1].body"
                                :key="index"
                            >
                                <a
                                    class="dib"
                                    :href="
                                        item.body[0].attributeMap.href.value
                                            .value
                                    "
                                >
                                    <div class="img-container">
                                        <img
                                            v-if="
                                                item.body[0].body[0]
                                                    .attributeMap.isexist.value
                                                    .value == 1
                                            "
                                            :src="
                                                item.body[0].body[0]
                                                    .attributeMap.src.value
                                                    .value
                                            "
                                            :alt="
                                                item.body[0].body[0]
                                                    .attributeMap.alt.value
                                                    .value
                                            "
                                        />
                                        <img
                                            v-else
                                            src="@/assets/img/no-picture2.jpg"
                                            alt=""
                                        />
                                    </div>
                                    <div class="text-container">
                                        <div
                                            class="fs14 c3 elli2 title"

                                        >
                                            {{
                                                item.body[0].body[1].body[0]
                                                    .value
                                            }}
                                        </div>
                                        <div class="fs12 c6 elli">
                                            {{
                                                item.body[0].body[2].body[0]
                                                    .value
                                            }}
                                        </div>
                                        <!-- <div class="fs12 c6 elli fzs" v-html="item.body[0].body[3].rawHtml"></div> -->
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <!-- 右边 -->
                        <div id="kkhqjnld-reRight" class="fr">
                            <!-- <a :href="ast['kkhnzbxa-recommend'].body[2].body[0].attributeMap.href.value.value" class="img-container" @click="handle_xd"> -->
                            <a
                                href="javascript:void(0);"
                                class="img-container"
                                @click="handle_xd"
                            >
                                <img
                                    :src="
                                        ast['kkhnzbxa-recommend'].body[2]
                                            .body[0].body[0].attributeMap.src
                                            .value.value
                                    "
                                    :alt="
                                        ast['kkhnzbxa-recommend'].body[2]
                                            .body[0].body[0].attributeMap.alt
                                            .value.value
                                    "
                                />
                            </a>
							<!-- 暂时不渲染 -->
                            <div v-if="0" class="site-announcement">
                                <div class="fwb fs14 c_theme">
                                    {{
                                        ast["kkhp9pab-adv"].body[0].body[0]
                                            .value
                                    }}
                                </div>
                                <ul class="site-list">
                                    <li
                                        class="cf"
                                        v-for="item in noticeList"
                                        :key="item.id"
                                    >
                                        <a
                                            href="javascript:void(0);"
                                            class="fs12 elli fl"
                                            style="width: 120px"
                                            @click="open_notice(item.id)"
                                            >{{ item.title }}</a
                                        >
                                        <span class="fr fs12 c6">{{
                                            item.add_time
                                        }}</span>
                                    </li>
                                    <li class="page-change">
                                        <el-pagination
                                            small
                                            layout="prev, next"
                                            prev-text="上一页"
                                            next-text="下一页"
                                            background
                                            :page-size="pageSize"
                                            @current-change="handle_current"
                                            :total="totalPage"
                                            :hide-on-single-page="true"
                                        >
                                        </el-pagination>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 最新供应 -->
            <div id="kkhv8wmo-newest">
                <div class="w1200 dib tl">
                    <div class="kkhninjr-title dib">
                        <img
                            class="mr10 vm"
                            src="@/assets/img/index/title-before.png"
                            alt=""
                        />
                        <span class="fs16 fwb c_theme vm mr10">{{
                            ast["kkhvcjhb-newest"].body[0].body[0].body[0].value
                        }}</span>
                        <a
                            :href="
                                ast['kkhvcjhb-newest'].body[0].body[1]
                                    .attributeMap.href.value.value
                            "
                            class="c9 fs12 vb"
                            >{{
                                ast["kkhvcjhb-newest"].body[0].body[1].body[0]
                                    .value
                            }}</a
                        >
                    </div>
                    <div class="cf">
                        <!-- 左边--列表 -->
                        <ul id="kkhotfo8-newestList" class="fl">
                            <li
                                v-for="(item, index) in ast['kkhvcjhb-newest']
                                    .body[1].body"
                                :key="index"
                            >
                                <a
                                    class="dib"
                                    :href="
                                        item.body[0].attributeMap.href.value
                                            .value
                                    "
                                >
                                    <div class="img-container">
                                        <img
                                            v-if="
                                                item.body[0].body[0]
                                                    .attributeMap.isexist.value
                                                    .value == 1
                                            "
                                            :src="
                                                item.body[0].body[0]
                                                    .attributeMap.src.value
                                                    .value
                                            "
                                            :alt="
                                                item.body[0].body[0]
                                                    .attributeMap.alt.value
                                                    .value
                                            "
                                        />
                                        <img
                                            v-else
                                            src="@/assets/img/no-picture2.jpg"
                                            alt=""
                                        />
                                    </div>
                                    <div class="text-container">
                                        <div
                                            class="fs14 c3 elli2 title"

                                        >
                                            {{
                                                item.body[0].body[1].body[0]
                                                    .value
                                            }}
                                        </div>
                                        <div class="fs12 c6 elli">
                                            {{
                                                item.body[0].body[2].body[0]
                                                    .value
                                            }}
                                        </div>
                                        <!-- <div class="fs12 c6 elli fzs" v-html="item.body[0].body[3].rawHtml"></div> -->
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <!-- 右边 -->
                        <div id="kkhqjnld-newestRight" class="fr">
                            <!-- <a :href="ast['kkhvcjhb-newest'].body[2].body[0].attributeMap.href.value.value" class="img-container1">
								<img :src="ast['kkhvcjhb-newest'].body[2].body[0].body[0].attributeMap.src.value.value" :alt="ast['kkhvcjhb-newest'].body[2].body[0].body[0].attributeMap.alt.value.value">
							</a>
							<a :href="ast['kkhvcjhb-newest'].body[2].body[1].attributeMap.href.value.value" class="img-container1">
								<img :src="ast['kkhvcjhb-newest'].body[2].body[1].body[0].attributeMap.src.value.value" :alt="ast['kkhvcjhb-newest'].body[2].body[1].body[0].attributeMap.alt.value.value">
							</a> -->
                            <!-- <a :href="ast['kkhvcjhb-newest'].body[2].body[2].attributeMap.href.value.value" class="img-container">
								<img :src="ast['kkhvcjhb-newest'].body[2].body[2].body[0].attributeMap.src.value.value" :alt="ast['kkhvcjhb-newest'].body[2].body[2].body[0].attributeMap.alt.value.value">
							</a> -->
                            <div class="dib lxfs-container tc">
                                <div
                                    class="fs12 cw mb16"
                                    style="margin-top: 30px"
                                >
                                    {{ ast.kmctsmcp_lxwm.body[0].value }}
                                </div>
                                <div class="fs12 cw mb16">
                                    {{ ast.kmctsmcp_mail.body[0].value }}
                                </div>
                                <img src="@/assets/img/gzh.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 新闻资讯 -->
            <div id="kkhxvzc0-news">
                <div class="w1200 dib tl">
                    <!-- 标题 -->
                    <div class="kkhninjr-title dib">
                        <img
                            class="mr10 vm"
                            src="@/assets/img/index/title-before.png"
                            alt=""
                        />
                        <span class="fs16 fwb c_theme vm mr10">{{
                            ast.klhs9iw3_news.body[0].body[0].value
                        }}</span>
                        <a
                            :href="
                                ast.klhs9iw3_news.body[1].attributeMap.href
                                    .value.value
                            "
                            class="c9 fs12 vb"
                            >{{ ast.klhs9iw3_news.body[1].body[0].value }}</a
                        >
                    </div>
                    <!-- 新闻列表 -->
                    <ul class="news-list">
                        <li
                            v-for="(item, index) in ast.klhsdt1w_news.body"
                            :key="index"
                            @mouseenter="index_newsHover(item)"
                            @mouseleave="index_newsOutHover(item)"
                        >
                            <a
                                :href="
                                    item.body[0].attributeMap.href.value.value
                                "
                            >
                                <!-- 文本容器 -->
                                <div class="text-container">
                                    <div class="fs16 c6 date">
                                        {{ item.body[0].body[0].body[0].value }}
                                    </div>
                                    <div class="fs16 c6 fwb title elli2">
                                        {{ item.body[0].body[1].body[0].value }}
                                    </div>
                                    <div class="kn5u6vi5_box fs14 c6 content elli2">
                                        {{ item.body[0].body[2].body[0].value }}
                                    </div>
                                </div>
                                <!-- 新闻图片 -->
                                <div class="img-container">
                                    <img
                                        :src="
                                            item.body[0].body[3].attributeMap
                                                .src.value.value
                                        "
                                        :alt="
                                            item.body[0].body[3].attributeMap
                                                .alt.value.value
                                        "
                                    />
                                </div>
                                <!-- 右上箭头 -->
                                <div
                                    class="icon-arrow-top"
                                    v-show="!item.index_newsActive"
                                >
                                    <img
                                        src="@/assets/img/index/arrow-top-right.png"
                                        alt=""
                                    />
                                </div>
                                <!-- hover-时出现向左箭头 -->
                                <div
                                    class="icon-arrow"
                                    v-show="item.index_newsActive"
                                >
                                    <img
                                        src="@/assets/img/index/arrow-right.png"
                                        alt=""
                                    />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 技术问答 -->
            <div id="kmcs7lcj-tech">
                <div class="w1200 dib tl">
                    <!-- 标题 -->
                    <div class="kkhninjr-title dib">
                        <img
                            class="mr10 vm"
                            src="@/assets/img/index/title-before.png"
                            alt=""
                        />
                        <span class="fs16 fwb c_theme vm mr10">{{
                            ast.klhs9iw3_tech.body[0].body[0].value
                        }}</span>
                        <a
                            :href="
                                ast.klhs9iw3_tech.body[1].attributeMap.href
                                    .value.value
                            "
                            class="c9 fs12 vb"
                            >{{ ast.klhs9iw3_news.body[1].body[0].value }}</a
                        >
                    </div>
                    <!-- 问答列表 -->
                    <ul class="kmcsl5ko_qalist">
                        <li
                            v-for="(item, index) in ast.kmcsa7mh_techlist.body"
                            :key="index"
                        >
                            <a
                                :href="
                                    item.body[0].attributeMap.href.value.value
                                "
                                class="dib"
                            >
                                <img
                                    src="@/assets/img/qa/q.png"
                                    alt=""
                                    class="vt mr14 dib"
                                />
                                <div class="title dib">
                                    <span class="fs14">{{
                                        item.body[0].body[0].body[0].value
                                    }}</span>
                                </div>
                                <img
                                    src="@/assets/img/qa/a.png"
                                    alt=""
                                    class="vt mr14 dib"
                                />
                                <div class="answer dib">
                                    <span class="fs12">{{
                                        item.body[0].body[1].body[0].value
                                    }}</span>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 我们的服务 -->
            <div id="kki1eg2m-service">
                <div class="w1200 dib">
                    <div class="fs16 fwb cw mt25 service">
                        {{ ast["kki1lf09-service"].body[0].body[0].value }}
                    </div>
                    <ul class="service-list">
                        <!-- 原料药进口 -->
                        <li>
                            <a
                                :href="
                                    ast['kki1lf09-service'].body[1].body[0]
                                        .body[0].attributeMap.href.value.value
                                "
                            >
                                <div class="img-box">
                                    <svg class="icon fj" aria-hidden="true">
                                        <use xlink:href="#iconfeiji"></use>
                                    </svg>
                                </div>
                                <div class="fs14 cw fwb mb15 cn-name">
                                    {{
                                        ast["kki1lf09-service"].body[1].body[0]
                                            .body[0].body[0].body[0].value
                                    }}
                                </div>
                                <div class="cw en-name">
                                    {{
                                        ast["kki1lf09-service"].body[1].body[0]
                                            .body[0].body[1].body[0].value
                                    }}
                                </div>
                            </a>
                        </li>
                        <!-- 中间体研发及生产 -->
                        <li>
                            <a
                                :href="
                                    ast['kki1lf09-service'].body[1].body[1]
                                        .body[0].attributeMap.href.value.value
                                "
                            >
                                <div class="img-box">
                                    <svg class="icon zjj" aria-hidden="true">
                                        <use
                                            xlink:href="#iconshengchanshebei"
                                        ></use>
                                    </svg>
                                </div>
                                <div class="fs14 cw fwb mb15 cn-name">
                                    {{
                                        ast["kki1lf09-service"].body[1].body[1]
                                            .body[0].body[0].body[0].value
                                    }}
                                </div>
                                <div
                                    class="cw en-name"
                                    v-html="
                                        ast['kki1lf09-service'].body[1].body[1]
                                            .body[0].body[1].body[0].value
                                    "
                                ></div>
                            </a>
                        </li>
                        <!-- 参比制剂进口 -->
                        <li>
                            <a
                                :href="
                                    ast['kki1lf09-service'].body[1].body[2]
                                        .body[0].attributeMap.href.value.value
                                "
                            >
                                <div class="img-box">
                                    <svg class="icon cb" aria-hidden="true">
                                        <use
                                            xlink:href="#icon-yiliao-yaopin"
                                        ></use>
                                    </svg>
                                </div>
                                <div class="fs14 cw fwb mb15 cn-name">
                                    {{
                                        ast["kki1lf09-service"].body[1].body[2]
                                            .body[0].body[0].body[0].value
                                    }}
                                </div>
                                <div class="cw en-name">
                                    {{
                                        ast["kki1lf09-service"].body[1].body[2]
                                            .body[0].body[1].body[0].value
                                    }}
                                </div>
                            </a>
                        </li>
                        <!-- 兽药原料 -->
                        <li>
                            <a
                                :href="
                                    ast['kki1lf09-service'].body[1].body[3]
                                        .body[0].attributeMap.href.value.value
                                "
                            >
                                <div class="img-box">
                                    <svg class="icon sy" aria-hidden="true">
                                        <use xlink:href="#icongoujiaoyin"></use>
                                    </svg>
                                </div>
                                <div class="fs14 cw fwb mb15 cn-name">
                                    {{
                                        ast["kki1lf09-service"].body[1].body[3]
                                            .body[0].body[0].body[0].value
                                    }}
                                </div>
                                <div class="cw en-name">
                                    {{
                                        ast["kki1lf09-service"].body[1].body[3]
                                            .body[0].body[1].body[0].value
                                    }}
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 公告弹窗 -->
        <index-notice ref="klngccip_notice"></index-notice>
        <!-- 询单弹窗 -->
        <inquiry-sheet ref="dialog"></inquiry-sheet>
        <!-- 底部 -->
        <index-footer></index-footer>
    </div>
</template>

<script>
import IndexFooter from "../include/index-footer.vue";
import indexHeader from "../include/index-header.vue";
import IndexNotice from "../include/index-notice.vue";
import InquirySheet from "../include/inquiry-sheet.vue";
export default {
    components: { indexHeader, IndexFooter, IndexNotice, InquirySheet },
    name: "kl_module1_index",
    data() {
        return {
            // 新闻资讯-hover状态
            index_newsActive: false,
            // 系统公告总页数
            totalPage: 50,
            // 分页大小
            pageSize: 10,
            // 列表数组
            noticeList: [],
        };
    },
    created() {
        this.$get("Announcement/lists", {
            page: 1,
        }).then((rsp) => {
            if (rsp.data.state == 0) {
                this.totalPage = rsp.data.data.total;
                this.pageSize = rsp.data.data.per_page;
                this.noticeList = rsp.data.data.data;
                this.noticeList.forEach((item) => {
                    item.add_time = this.$u.util.formatDay(
                        item.add_time * 1000
                    );
                });
            }
        });
    },
    methods: {
        // 新闻资讯-enter状态
        index_newsHover(item) {
            var _this = this;
            this.$nextTick(function () {
                var items = this.ast["kkhxxnjk-news"].body[1].body;
                items.forEach(function (item) {
                    _this.$set(item, "index_newsActive", false);
                });
                this.$set(item, "index_newsActive", true);
            });
        },
        // 新闻资讯-leave状态
        index_newsOutHover(item) {
            this.$set(item, "index_newsActive", false);
        },
        // 打开公告弹窗
        open_notice(id) {
            this.$refs.klngccip_notice.klng99h4_dialog = true;
            this.$refs.klngccip_notice.handle_open(id);
        },
        // 系统公告分页-处理当前页
        handle_current(newpage) {
            this.$get("Announcement/lists", {
                page: newpage,
            }).then((rsp) => {
                if (rsp.data.state == 0) {
                    this.totalPage = rsp.data.data.total;
                    this.pageSize = rsp.data.data.per_page;
                    this.noticeList = rsp.data.data.data;
                    this.noticeList.forEach((item) => {
                        item.add_time = this.$u.util.formatDay(
                            item.add_time * 1000
                        );
                    });
                }
            });
        },
        handle_xd() {
            // 处理子组件 -询单
            this.$refs.dialog.dialogVisible = true;
        },
    },
};
</script>

<style lang="less">
@import (reference) "@/assets/less/base.less";
// 推荐产品
#kkgqz3uu-recommend {
    background: url("~@/assets/img/index/recommend-bg.png") no-repeat;
    background-size: 100% 100%;
    padding-bottom: 20px;
    .kkhninjr-title {
        padding-bottom: 15px;
        padding-top: 25px;
        margin-right: 10px;
    }
    // 推荐产品列表
    #kkhotfo8-reList {
        width: 970px;
        li {
            .dib;
            border-radius: 5px;
            margin-right: 10px;
            margin-bottom: 10px;
            box-sizing: border-box;
            width: 230px;
            a {
                width: 230px;
                // 图片容器
                .img-container {
                    .dib;
                    background-color: #fff;
                    line-height: 135px;
                    .tc;
                    width: 230px;
                    height: 135px;
                    line-height: 135px;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                    img {
                        .vm;
                        max-width: 230px;
                        max-height: 135px;
                        border-top-left-radius: 5px;
                        border-top-right-radius: 5px;
                    }
                }
                // 文字容器
                .text-container {
                    background-color: #f6f6f6;
                    padding: 10px 15px;
                    line-height: 25px;
                    border-bottom-left-radius: 5px;
                    border-bottom-right-radius: 5px;
                    transition: all 0.7s;
                    div {
                        .fs12;
                        .elli;
                    }
                    sub {
                        .fs12;
                    }
                }
                &:hover {
                    box-shadow: 0 0 10px #ccc;
                    .text-container {
                        background-color: @c_theme;
                        .title {
                            .fwb;
                        }
                        div {
                            color: #fff !important;
                        }
                    }
                }
            }
        }
    }
    // 右边部分
    #kkhqjnld-reRight {
        width: 230px;
        // 图片容器
        .img-container {
            .dib;
            width: 230px;
            height: 230px;
            margin-bottom: 10px;
            img {
                border-radius: 5px;
                width: 230px;
                height: 230px;
            }
        }
        // 网站公告
        .site-announcement {
            box-sizing: border-box;
            width: 230px;
            height: 230px;
            border-radius: 5px;
            padding: 15px 10px;
            background-color: #fff;
            overflow: hidden;
            .site-list {
                margin-top: 10px;
                overflow: auto;
                height: 180px;
                li {
                    height: 30px;
                    line-height: 30px;
                }
                &::-webkit-scrollbar {
                    width: 3px;
                }

                /* --- 滚动条里面的滚动块 --- */
                &::-webkit-scrollbar-thumb {
                    width: 6px;
                    background-color: #dbdbdb;
                    border-radius: 5px;
                }
                .page-change {
                    padding-left: 5px;
                    .btn-next,
                    .btn-prev {
                        span {
                            padding: 2px 10px;
                            border: 1px solid #ccc;
                            line-height: 16px;
                        }
                    }
                }
            }
        }
    }
}
// 最新供应
#kkhv8wmo-newest {
    background-size: 100% 100%;
    padding-bottom: 20px;
    .kkhninjr-title {
        padding-bottom: 15px;
        padding-top: 40px;
        margin-right: 10px;
    }
    // 最新供应列表
    #kkhotfo8-newestList {
        width: 970px;
        li {
            .dib;
            border-radius: 5px;
            margin-right: 10px;
            margin-bottom: 10px;
            border: 1px solid #eee;
            width: 230px;
            box-sizing: border-box;
            &:hover {
                border-color: #fff;
            }
            a {
                width: 230px;
                box-sizing: border-box;
                border-radius: 5px;
                // 图片容器
                .img-container {
                    .dib;
                    background-color: #fff;
                    line-height: 135px;
                    .tc;
                    width: 228px;
                    height: 135px;
                    line-height: 135px;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                    img {
                        .vm;
                        max-width: 228px;
                        max-height: 135px;
                        border-top-left-radius: 5px;
                        border-top-right-radius: 5px;
                    }
                }
                // 文字容器
                .text-container {
                    background-color: #f6f6f6;
                    padding: 10px 15px;
                    line-height: 25px;
                    border-bottom-left-radius: 5px;
                    border-bottom-right-radius: 5px;
                    transition: all 0.7s;
                    div {
                        .fs12;
                        .elli;
                    }
                    sub {
                        .fs12;
                    }
                }
                &:hover {
                    box-shadow: 0 0 10px #ccc;
                    .text-container {
                        background-color: @c_theme;
                        .title {
                            .fwb;
                        }
                        div {
                            color: #fff !important;
                        }
                    }
                }
            }
        }
    }
    // 右边部分
    #kkhqjnld-newestRight {
        width: 230px;
        // 图片容器1
        .img-container1 {
            .dib;
            width: 230px;
            height: 124px;
            margin-bottom: 10px;
            img {
                border-radius: 5px;
                width: 230px;
                height: 124px;
            }
        }
        // 图片容器
        .img-container {
            .dib;
            width: 230px;
            height: 233px;
            margin-bottom: 10px;
            img {
                border-radius: 5px;
                width: 230px;
                height: 233px;
            }
        }
        // 联系我们
        .lxfs-container {
            background: url("~@/assets/img/index/zx-bg.png");
            background-size: 100% 100%;
            width: 230px;
            height: 230px;
            img {
                width: 100px;
            }
        }
    }
}
// 新闻资讯
#kkhxvzc0-news {
    margin-bottom: 20px;
    // 标题
    .kkhninjr-title {
        padding-bottom: 15px;
        padding-top: 15px;
        margin-right: 10px;
    }
    // 列表
    .news-list {
        li {
            .dib;
            width: 400px;
            box-sizing: border-box;
            border-right: 1px solid #eee;
            padding: 30px;
            padding-bottom: 10px;
            transition: all 0.7s;
            border-radius: 5px;
            .text-container {
                .date {
                    line-height: 25px;
                    .elli;
                    transition: all 0.7s;
                }
                .title {
                    line-height: 30px;
                    height: 60px;
                    transition: all 0.7s;
                }
                .content {
                    line-height: 25px;
                    margin-bottom: 15px;
                    margin-top: 5px;
                }
            }
            .img-container {
                width: 340px;
                height: 180px;
                img {
                    width: 340px;
                    height: 180px;
                }
            }
            // 箭头-右上
            .icon-arrow-top {
                width: 40px;
                height: 40px;
                border-radius: 40px;
                margin-top: 20px;
                .dib;
                line-height: 40px;
                font-size: 18px;
                margin-bottom: 10px;
            }
            // 箭头-右
            .icon-arrow {
                width: 40px;
                height: 40px;
                border-radius: 40px;
                margin-top: 20px;
                .dib;
                .tc;
                line-height: 40px;
                font-size: 18px;
                margin-bottom: 10px;
                background-color: @c_theme;
            }
            &:hover {
                box-shadow: 0 0 10px #ccc;
                border-color: #fff;
                .text-container {
                    .date {
                        .fwb;
                        .c_theme;
                    }
                    .title {
                        .c_theme;
                    }
                }
            }
        }
    }
}
// 我们的服务
#kki1eg2m-service {
    background: url("~@/assets/img/index/service-bg.png");
    background-size: 100% 100%;
    .service {
        &::before {
            content: "";
            .dib;
            .vm;
            width: 35px;
            height: 1px;
            background-color: #999;
            margin-right: 10px;
        }
        &::after {
            content: "";
            .dib;
            .vm;
            width: 35px;
            height: 1px;
            background-color: #999;
            margin-left: 10px;
        }
    }
    .service-list {
        margin-top: 50px;
        margin-bottom: 65px;
        li {
            .dib;
            margin: 0 20px;
            transition: all 0.5s;
            .vt;
            a {
                .tc;
                .dib;
                // 图片盒子
                .img-box {
                    .dib;
                    background-color: #fff;
                    width: 70px;
                    height: 70px;
                    border-radius: 50px;
                    .tc;
                    line-height: 58px;
                    font-size: 45px;
                    margin-bottom: 30px;
                    .fj,
                    .zjj,
                    .cb {
                        color: @c_theme;
                        font-size: 30px;
                    }
                    .sy {
                        color: @c_theme;
                        font-size: 32px;
                    }
                }
                // 英文名称
                .en-name {
                    width: 180px;
                    word-break: break-all;
                    .fs12;
                    line-height: 20px;
                    height: 40px;
                    transition: all 0.5s;
                }
            }
            &:hover {
                .en-name {
                    color: @c_theme;
                }
                .cn-name {
                    color: @c_theme;
                }
                .img-box {
                    background-color: @c_theme;
                    // 图标
                    .fj,
                    .zjj,
                    .cb,
                    .sy {
                        color: #fff;
                    }
                }
            }
        }
    }
}
// 技术问答
#kmcs7lcj-tech {
    .kmcsl5ko_qalist {
        .mt20;
        li {
            margin-right: 15px;
            margin-bottom: 15px;
            .dib;
            &:nth-child(2n) {
                margin-right: 0;
                margin-bottom: 0;
            }
            a {
                .dib;
                background-color: #f4f4f4;
                padding: 20px;
                width: 552px;
                transition: all 0.5s;
                &:hover {
                    background-color: #fff;
                    box-shadow: 0 0 10px #eee;
                }
                .title {
                    line-height: 20px;
                    width: 520px;
                    color: #333;
                }
                .answer {
                    line-height: 18px;
                    .c9;
                    height: 40px;
                    overflow: hidden;
                    width: 520px;
                }
            }
        }
    }
}

.kn5u6vi5_box {
	height: calc(2em * 1.72 + 0.8px);
}
</style>
